module.exports = __webpack_public_path__ + "img/botaosttteofilootonisetsemg.bc7f1b60.png";